import {
  createFileRoute, isRedirect, useLoaderData,
} from '@tanstack/react-router';
import { thirdPartyLoader, ThirdPartyLoaderResponse } from '../../../../utils/third-party-loader';
import ThirdPartyPage from '../../../../components/pages/third-party-page';

interface ThirdPartyLoaderParams {
  params: { accountSlug: string; trackingId: string };
}

const TradeReferenceRoute = () => {
  const loaderData = useLoaderData({ from: '/trade-references/$accountSlug/$trackingId/' }) as ThirdPartyLoaderResponse;
  return <ThirdPartyPage
    loaderData={loaderData}
    routeFrom='/trade-references/$accountSlug/$trackingId/'
         />;
};

export const Route = createFileRoute('/trade-references/$accountSlug/$trackingId/')({
  loader: async ({ params: { accountSlug, trackingId } }: ThirdPartyLoaderParams) => {
    try {
      const result = await thirdPartyLoader({
        accountSlug,
        trackingId,
      });
      if (result.type === 'error') {
        window.DD_RUM?.addError(result.error, {
          source: 'trade-reference-loader',
          accountSlug,
          trackingId,
        });
      }
      return result;
    } catch (error) {
      if (isRedirect(error)) throw error;
      window.DD_RUM?.addError(error, {
        source: 'trade-reference-loader-unhandled',
        accountSlug,
        trackingId,
      });
      throw error;
    }
  },
  component: TradeReferenceRoute,
});
